import Script from "./Script";

export default Script;